import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SaveInventoryLookup'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SaveInventoryLookupStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SaveInventoryLookupStore",
			variables: false,
		})
	}
}

export async function load_SaveInventoryLookup(params) {
  await initClient()

	const store = new SaveInventoryLookupStore()

	await store.fetch(params)

	return {
		SaveInventoryLookup: store,
	}
}
